import { Controller } from "stimulus"

export default class extends Controller
  connect: ->
    @element.dispatchEvent(new CustomEvent('cocoonElementAdded', { bubbles: true }))

  disconnect: ->
    @element.dispatchEvent(new CustomEvent('cocoonElementRemoved', { bubbles: true }))